import React from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { Drawer } from '@mafc/trolly';

import useAction from 'hooks/useAction';
import { ICheckoutState } from 'pages/Checkout/redux/reducer';

import { AppliedVoucher } from 'network/response/ICart';
import { ICartState } from 'pages/Cart/redux/reducer';
import AvailablePromotionsDrawerBody from './AvailablePromotionsDrawerBody';
import AvailablePromotionsDrawerHeader from './AvailablePromotionsDrawerHeader';
import COLORS from 'theme/colors';
import { removePromo } from 'pages/Checkout/redux/actions/promo.action';
import { IAvailablePromotions } from '../AvailablePromotions/redux/AvailablePromotions.reducer';
import { IPromo } from 'pages/Checkout/redux/reducer/promo.reducer';

const AvailablePromotionsDrawer: React.FC<{
  isOpen: boolean;
  closeDrawer: () => void;
  enterCodeBtnClickHandler: () => void;
}> = ({ isOpen, closeDrawer, enterCodeBtnClickHandler }) => {
  const { t } = useTranslation();
  const {
    availablePromotions,
    appliedPromo,
    promo: promoState,
  }: {
    appliedPromo: AppliedVoucher | null;
    promo: IPromo;
    availablePromotions: IAvailablePromotions;
  } = useSelector((state: { cart: ICartState; checkout: ICheckoutState }) => {
    return {
      availablePromotions: state.checkout.availablePromotions,
      appliedPromo: state.cart.cartData.appliedVouchers
        ? state.cart.cartData.appliedVouchers[0]
        : null,
      promo: state.checkout.promo,
    };
  });

  const [removePromoAction] = useAction(removePromo);

  const removeHandler = () => {
    removePromoAction(appliedPromo && appliedPromo.voucherCode, t);
  };

  return (
    <Drawer
      anchor={['bottom', null, 'right']}
      isOpen={isOpen}
      onClose={closeDrawer}
      title={<AvailablePromotionsDrawerHeader />}
      variant="float"
      containerStyles={{
        borderTopLeftRadius: [4, null, null, 0],
        borderTopRightRadius: [4, null, null, 0],
        height: ['85%', null, '100%'],
      }}
      isTitleBorder={false}
      contentStyles={{ paddingTop: 0, borderRadius: '20px', color: COLORS.BLACK }}
      width={[null, null, '480px']}
      data-testid="available-promotions-drawer"
    >
      <AvailablePromotionsDrawerBody
        availablePromotions={availablePromotions}
        appliedPromo={appliedPromo}
        promoState={promoState}
        onPromoRemove={removeHandler}
        enterCodeBtnClickHandler={enterCodeBtnClickHandler}
      />
    </Drawer>
  );
};

export default AvailablePromotionsDrawer;
